import { formatName } from '@edge/spark/utils'
import { UserAttributes } from '../generated/graphql'

export const pickUserAttributes = (attrs?: UserAttributes | null | undefined) => {
    return {
        auctionAccessNumber: attrs?.auctionAccessNumber || '',
        authenticationId: attrs?.authenticationId || '',
        authenticationSource: attrs?.authenticationSource || '',
        authenticationUsername: attrs?.authenticationUsername || '',
        createdAt: attrs?.createdAt || '',
        createdBy: attrs?.createdBy || '',
        databaseId: attrs?.databaseId || 0,
        email: attrs?.email || '',
        familyName: attrs?.lastName || '',
        firstName: attrs?.firstName || '',
        isAdmin: attrs?.isGlobalAdmin || false,
        isGlobalAdmin: attrs?.isGlobalAdmin || false,
        isLocked: attrs?.isLocked || false,
        lastName: attrs?.lastName || '',
        lastSeenAt: attrs?.lastSeenAt || '',
        lockedAt: attrs?.lockedAt || '',
        lockedBy: attrs?.lockedBy || '',
        mobilePhone: attrs?.mobilePhone || '',
        name: attrs?.firstName || '',
        formattedName: formatName({ firstName: attrs?.firstName, lastName: attrs?.lastName }),
        notes: attrs?.notes || '',
        updatedAt: attrs?.updatedAt || '',
        updatedBy: attrs?.updatedBy || '',
        userId: attrs?.authenticationId || '',
        username: attrs?.authenticationUsername || '',
        workPhone: attrs?.workPhone || '',
    }
}
